import { Injectable } from '@angular/core'
import { KirjanpidonProjekti, Projekti } from '@lemon/core-firebase/model/kirjanpito-projektit'
import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { KirjanpitoUriService } from 'app/_jaettu-lemonator/service/kirjanpito-uri.service'
import { Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { PROJEKTI_VARIT, ProjektinVarit, ProjektitService } from '../../../_jaettu-angular/projektit.service'
import { AsiakasService } from '../asiakas/asiakas.service'

@Injectable()
export class ProjektiServiceLemonatorImpl implements ProjektitService {
  naytettavatKirjanpitoprojektitObservable: Observable<Projekti[]>
  naytaProjektitObservable: Observable<boolean>

  lemonTreeAvain = 'jzATU474P4BRCkEANZ1H'

  constructor(
    private _kirjanpitoUriService: KirjanpitoUriService,
    private _lemonatorFirebase: FirebaseLemonator,
    private _asiakasService: AsiakasService,
  ) {
    this.naytettavatKirjanpitoprojektitObservable = this._asiakasService.nykyinenAsiakasObservable.pipe(
      switchMap(asiakas => {
        if (!asiakas) {
          return of<Projekti[]>([])
        }
        const uri = this._kirjanpitoUriService.annaKirjanpitoProjektitCollection(this.lemonTreeAvain)
        return this._lemonatorFirebase
          .firestoreCollection<KirjanpidonProjekti>(uri)
          .listen()
          .pipe(map(projektit => projektit.filter(p => p && p.viewableInLemonator && p.avain && p.nimi).map(p => ({ avain: p.avain, nimi: p.nimi }) as Projekti)))
      }),
    )

    this.naytaProjektitObservable = this.naytettavatKirjanpitoprojektitObservable.pipe(map(projektit => !!projektit?.length))
  }

  annaProjektinVarit(projektiAvain: string): ProjektinVarit {
    let sum = 0
    for (const char of projektiAvain) {
      sum += char.charCodeAt(0)
    }
    const index = sum % PROJEKTI_VARIT.length
    return PROJEKTI_VARIT[index]
  }
}
